import React, { useEffect, useState } from "react";
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, TextField, MenuItem, Select, FormControl,
    InputLabel, RadioGroup, FormControlLabel, Radio,
    Box,
    Typography,
    Modal,
    Backdrop,
    Fade,
    IconButton,
    Drawer,
    useTheme,
    useMediaQuery
} from "@mui/material";
import BASE_URL, { COMMUNITYADMINS } from "../../NetworkConfig/ApiConfig";
import { Add, ArrowRight, CloseRounded, Done, DoneOutline, PersonSearchOutlined, Search } from "@mui/icons-material";
import { CircleLoader, BounceLoader, ClipLoader } from 'react-spinners'


const ApplicationUserSearchPopup = ({ open, onClose, width = 420, onSelect = () => { } }) => {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    const [search, setSearch] = useState("")
    const [selectedTab, setSelectedTab] = useState(0)
    const [loading, setLoading] = useState(false)
    const [oldApplications, setOldApplicatios] = useState([])
    const [smartApplyApplications, setSmartApplyApplications] = useState([])

    useEffect(() => {
        if (search.length > 0) {
            const delayDebounceFn = setTimeout(() => {
                if (selectedTab == 0) {
                    searchInOldApplications(search)
                } else {
                    searchInSmartApplyApplications(search)
                }
            }, 500); // 500ms delay
            return () => clearTimeout(delayDebounceFn);
        } else {
            if (selectedTab == 0) {
                setOldApplicatios([])
            } else {
                setSmartApplyApplications([])
            }
        }
    }, [search]);


    const searchInOldApplications = async (q) => {
        try {
            setLoading(true)
            const token = localStorage.getItem("token");
            const response = await fetch(`${BASE_URL}/jobs/si-oa?q=${q}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "auth-token": token,
                },
            });
            const data = await response.json();
            console.log(data)
            if (data.success) {
                setOldApplicatios(data.response)
            }
            setLoading(false)
        } catch (error) {
            console.error(error)
            setLoading(false)
        }


    };

    const searchInSmartApplyApplications = async (q) => {
        try {
            setLoading(true)
            const token = localStorage.getItem("token");
            const response = await fetch(`${BASE_URL}/jobs/si-sa?q=${q}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "auth-token": token,
                },
            });
            const data = await response.json();

            if (data.success) {
                setSmartApplyApplications(data.response)
            }
            setLoading(false)
        } catch (error) {
            console.error(error)
            setLoading(false)
        }


    };



    const ItemJobApplications = ({ item, index }) => {

        const [showAnswers, setShowAnswers] = useState(false)

        return (
            <Box sx={{
                flexDirection: "column", display: "flex", alignSelf: "stretch", marginInline: "13px",
                background: "#ffffff08", borderRadius: "15px", px: "15px",
                py: "15px", marginBottom: "5px"
            }}>

                <Box sx={{ flexDirection: "row", alignItems: "center", display: "flex" }}>

                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <img
                            alt="profile-user"
                            width="35px"
                            height="35px"
                            src={`${item?.user?.image?.[0] ?? ""}`}
                            style={{
                                cursor: "pointer", objectFit: 'cover',
                                borderRadius: "50%",
                                border: "3px solid #ffffff10"
                            }}
                        />
                    </Box>
                    <Box sx={{ ml: "10px", mr: "20px", display: 'flex', flexDirection: 'column', alignItems: 'flex-start', flex: 1 }}>

                        <Typography color={"#ffffff"}
                            fontFamily={"poppins-reg"}
                            fontSize={"13px"} style={{ maxLines: 1, textOverflow: 'ellipsis', }} >{item?.user?.full_name ?? ""}</Typography>

                        <Box sx={{
                            display: 'flex', flexDirection: "row", alignItems: 'center',
                            gap: "5px"
                        }}>
                            <Typography color={"#ffffff90"}
                                fontFamily={"poppins-reg"}
                                style={{
                                }}
                                fontSize={"10.5px"}>{item?.user?.buzz_name}</Typography>
                        </Box>
                    </Box>


                    <Box
                        onClick={() => {
                            onSelect(item)
                            onClose()
                        }}
                        sx={{
                            width: "30px", height: "30px", borderRadius: "100px", background: "#ffffff10", alignItems: "center", justifyContent: "center",
                            display: "flex", cursor: "pointer"
                        }} >

                        <Add style={{ fontSize: "20px", color: "#ffffff", alignSelf: "center" }} />

                    </Box>

                </Box>
                <Typography
                    color={"#ffffffff"}
                    fontFamily={"poppins-reg"}
                    fontSize={"12px"}
                    style={{
                        borderRadius: "4px",
                        background: "#ffffff10",
                        paddingTop: "3px",
                        paddingBottom: "3px",
                        marginTop: "10px",
                        paddingLeft: "8px",
                        paddingRight: "8px",

                        alignSelf: "flex-start",
                        maxWidth: "100%",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap"
                    }}
                >
                    {item?.job?.title ?? ""}
                </Typography>

                <Box
                    onClick={() => {
                        setShowAnswers(!showAnswers)
                    }}
                    sx={{ flexDirection: "row", alignItems: "center", display: "flex", gap: "5px", paddingTop: "10px", cursor: "pointer" }} >
                    <Typography color={"#ad6bfd"}
                        fontFamily={"poppins-reg"}
                        style={{
                        }}
                        fontSize={"12px"}>{showAnswers ? `Hide ${item?.response?.length ?? 0} Answers` : `Show ${item?.response?.length ?? 0} Answers`}</Typography>

                    <ArrowRight style={{ fontSize: "15px", rotate: showAnswers ? "-90deg" : "90deg", color: "#ad6bfd" }} />

                </Box>

                {
                    showAnswers && item?.response?.map((itm, idx) => (
                        <Box sx={{
                            flexDirection: "column", display: "flex", alignSelf: "stretch", marginTop: "10px",
                            border: "1.5px solid #aaaaaa20", borderRadius: "15px", px: "10px", py: "10px", position: "relative",
                            wordWrap: "break-word"
                        }}>

                            <Typography color={"#ffffff90"}
                                fontFamily={"poppins-reg"}
                                style={{
                                    userSelect: "none", msUserSelect: "none", MozUserSelect: "none"
                                }}
                                fontSize={"11.5px"}>{item?.job?.questions?.[idx]?.question ?? `Question ${idx + 1}`}</Typography>

                            <Typography color={itm?.answer ? "#ffffff" : "#ad6bfd"}
                                fontFamily={"poppins-reg"}
                                style={{
                                    alignSelf: "stretch"
                                }}
                                fontSize={"12.5px"}>{itm?.answer ? itm?.answer : "NA"}</Typography>


                        </Box>
                    ))
                }


            </Box>
        )

    }



    const ItemSAApplications = ({ item, index }) => {

        const [showAnswers, setShowAnswers] = useState(false)

        return (
            <Box sx={{
                flexDirection: "column", display: "flex", alignSelf: "stretch", marginInline: "13px",
                background: "#ffffff08", borderRadius: "15px", px: "15px",
                py: "15px", marginBottom: "5px"
            }}>

                <Box sx={{ flexDirection: "row", alignItems: "center", display: "flex" }}>

                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <img
                            alt="profile-user"
                            width="35px"
                            height="35px"
                            src={`${item?.userId?.image?.[0] ?? ""}`}
                            style={{
                                cursor: "pointer", objectFit: 'cover',
                                borderRadius: "50%",
                                border: "3px solid #ffffff10"
                            }}
                        />
                    </Box>
                    <Box sx={{ ml: "10px", mr: "20px", display: 'flex', flexDirection: 'column', alignItems: 'flex-start', flex: 1 }}>

                        <Typography color={"#ffffff"}
                            fontFamily={"poppins-reg"}
                            fontSize={"13px"} style={{ maxLines: 1, textOverflow: 'ellipsis', }} >{item?.userId?.full_name ?? ""}</Typography>

                        <Box sx={{
                            display: 'flex', flexDirection: "row", alignItems: 'center',
                            gap: "5px"
                        }}>
                            <Typography color={"#ffffff90"}
                                fontFamily={"poppins-reg"}
                                style={{
                                }}
                                fontSize={"10.5px"}>{item?.userId?.buzz_name}</Typography>
                        </Box>
                    </Box>


                    <Box
                        onClick={() => {
                            onSelect(item)
                            onClose()
                        }}
                        sx={{
                            width: "30px", height: "30px", borderRadius: "100px", background: "#ffffff10", alignItems: "center", justifyContent: "center",
                            display: "flex", cursor: "pointer"
                        }} >

                        <Add style={{ fontSize: "20px", color: "#ffffff", alignSelf: "center" }} />

                    </Box>

                </Box>


                <Box
                    onClick={() => {
                        setShowAnswers(!showAnswers)
                    }}
                    sx={{ flexDirection: "row", alignItems: "center", display: "flex", gap: "5px", paddingTop: "10px", cursor: "pointer" }} >
                    <Typography color={"#ad6bfd"}
                        fontFamily={"poppins-reg"}
                        style={{
                        }}
                        fontSize={"12px"}>{showAnswers ? `Hide Details` : `Show Details`}</Typography>

                    <ArrowRight style={{ fontSize: "15px", rotate: showAnswers ? "-90deg" : "90deg", color: "#ad6bfd" }} />

                </Box>

                {
                    showAnswers && [
                        { question: "Full Name", answer: item?.full_name },
                        { question: "Email Address", answer: item?.email },
                        { question: "Mobile Number", answer: item?.mobileNumber },
                        { question: "Resume", answer: item?.resume?.url ?? "" },
                        { question: "Preferred Domains", answer: item.preferredDomains},
                        { question: "Total Experience", answer: item?.totalExperience },
                        { question: "Availability", answer: item?.availability },
                        { question: "Can Relocate", answer: item?.canRelocate ? "Yes" : "No" },
                        { question: "Portfolio Link", answer: item?.portfolio ?? "" }
                    ].map((itm, idx) => (
                        <Box sx={{
                            flexDirection: "column", display: "flex", alignSelf: "stretch", marginTop: "10px",
                            border: "1.5px solid #aaaaaa20", borderRadius: "15px", px: "10px", py: "10px", position: "relative",
                            wordWrap: "break-word"
                        }}>

                            <Typography color={"#ffffff90"}
                                fontFamily={"poppins-reg"}
                                style={{
                                    userSelect: "none", msUserSelect: "none", MozUserSelect: "none"
                                }}
                                fontSize={"11.5px"}>{itm?.question ?? `Question ${idx + 1}`}</Typography>

                            {
                                itm.answer && Array.isArray(itm.answer) && (
                                    <Box sx={{ flexDirection: "row", alignSelf: "stretch", display: "flex", flexWrap: "wrap", gap: "5px", marginTop: "5px" }} >

                                        {
                                            itm?.answer.map((ans, idxx) => (
                                                <Box sx={{
                                                    px: "10px", py: "5px", alignItems: "center", justifyContent: "center", display: "flex",
                                                    background: "#ad6bfd10", border: "1px solid #ad6bfd20", borderRadius: "5px"
                                                }}>
                                                    <Typography color={"#ad6bfd"}
                                                        fontFamily={"poppins-reg"}
                                                        style={{
                                                            alignSelf: "stretch"
                                                        }}
                                                        fontSize={"12.5px"}>{ans}</Typography>


                                                </Box>
                                            ))
                                        }

                                    </Box>
                                )
                            }

                            {
                                !Array.isArray(itm.answer) && (
                                    <Typography color={itm?.answer ? "#ffffff" : "#ad6bfd"}
                                        fontFamily={"poppins-reg"}
                                        style={{
                                            alignSelf: "stretch"
                                        }}
                                        fontSize={"12.5px"}>{itm?.answer ? itm?.answer : "NA"}</Typography>

                                )
                            }





                        </Box>
                    ))
                }


            </Box>
        )

    }



    return (
        <Drawer
            anchor={isMobile ? "bottom" : "right"}
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    width: isMobile ? "100%" : 420,
                    height: isMobile ? "85vh" : "100vh",
                    borderRadius: isMobile ? "20px 20px 0 0" : 0,
                    background: "#0f0e0fff",
                    flexDirection: 'column',
                    display: 'flex'
                }
            }}
        >



            {/* Body */}
            <Box sx={styles.body}>
                <Box sx={styles.header}>
                    <IconButton onClick={onClose}>
                        <CloseRounded />
                    </IconButton>
                    <span style={styles.title}>{"Search an application"}</span>

                </Box>


                <Box sx={{
                    flexDirection: 'row',
                    backgroundColor: "#ffffff10",
                    display: 'flex',
                    alignItems: "center",
                    px: "15px",
                    borderRadius: "10px",
                    marginInline: "15px",
                    border: "1px solid #aaaaaa30",
                    background: "#000000"
                }}>


                    <PersonSearchOutlined />

                    <input placeholder={selectedTab == 1 ? "Search by name, username or domain..." : "Search by name or username..."}
                        multiple={false}
                        value={search}
                        onChange={(v) => {
                            setSearch(v.target.value)
                        }}
                        style={{
                            outline: 'none',
                            backgroundColor: "#aaaaaa00",
                            borderWidth: 0,
                            paddingLeft: "15px",
                            paddingTop: "12px",
                            flex: 1,
                            display: 'flex',
                            fontSize: "14px",
                            paddingBottom: "12px",
                            fontFamily: 'poppins-reg',
                            color: "white"
                        }} />
                </Box>

                <Box sx={{ flexDirection: "row", display: "flex", alignItems: "center", marginInline: "15px", marginTop: "10px", gap: "5px" }} >

                    {
                        ["Old Applications", "Smart Apply Applications"].map((item, index) => (
                            <Box
                                onClick={() => {
                                    setSelectedTab(index)
                                }}
                                sx={{
                                    display: "flex", alignItems: "center", justifyContent: "center", px: "15px", py: "5px",
                                    background: selectedTab == index ? "#943bff" : "#ffffff10", borderRadius: "100px",
                                    flexDirection: "row", gap: "3px", cursor: "pointer"
                                }}>

                                {
                                    selectedTab == index && (
                                        <Done style={{ fontSize: "14px" }} />
                                    )
                                }

                                <Typography sx={{
                                    fontSize: "12px", color: "#ffffff", fontFamily: "poppins-reg",
                                }} >{item}</Typography>
                            </Box>
                        ))
                    }

                </Box>

                <Box sx={{ alignSelf: "stretch", height: "1px", background: "#aaaaaa10", my: "15px" }} />

                {
                    selectedTab == 0 && oldApplications.map((item, index) => (
                        <ItemJobApplications item={item} index={index} />
                    ))
                }

                {
                    selectedTab == 1 && smartApplyApplications.map((item, index) => (
                        <ItemSAApplications item={item} index={index} />
                    ))
                }


            </Box>
        </Drawer>

    );
};

const styles = {
    popup: (width) => ({
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width,
        maxWidth: "90%",
        maxHeight: "85vh",
        bgcolor: "#0f0f0f",
        borderRadius: 3,
        boxShadow: 24,
        overflow: "hidden"
    }),
    header: {
        display: "flex",
        alignItems: "center",
        px: 1,
        py: 2,
        borderBottom: "0px solid #aaaaaa20"
    },
    title: {
        fontSize: "14px",
        fontFamily: "poppins-reg"
    },
    body: {
        overflowY: "auto",
        display: 'flex',
        flexDirection: 'column',
        flex: 1
    }
};


export default ApplicationUserSearchPopup;
